import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolder1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folder-1"><path d="M3.75 3C2.7835 3 2 3.7835 2 4.75V18.25C2 19.2165 2.7835 20 3.75 20H20.25C21.2165 20 22 19.2165 22 18.25V7.75C22 6.7835 21.2165 6 20.25 6H12.5352C12.4516 6 12.3735 5.95822 12.3272 5.88867L10.9209 3.77927C10.5963 3.29243 10.0499 3 9.46482 3H3.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFolder1;
